import {
    Grid, Tooltip
} from "@mui/material";
import { useEffect, useState } from "react";
import { ListTablePaginated } from "src/general_components/ListTablePaginated";
import BuscadorGeneralMovimientos from "src/projects/gestion_documental/components/BuscadorDashboard/BuscadorGeneralMovimientos";
import { getComprobantesMovimientosPaginated, getComprobantesMovimientos } from "src/projects/gestion_documental/helpers/ComprobantesData";
import { esArray, esObjetoNoVacio } from "src/general_components/functionEsArray";
import {
    GridActionsCellItem,
} from "@mui/x-data-grid";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { SimpleDialogComponent } from "src/general_components/SimpleDialogComponent";
import ComprobantesTable from "src/projects/gestion_documental/components/ComprobantesTable";
import Button from "@mui/material/Button";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import createMovimientosPDF from "src/projects/gestion_documental/components/MovimientosHtmlPdf";

export const DashboardDlysMovimientos = () => {

    const [searchQuery, setSearchQuery] = useState("");
    const [buscadorEjecutado, setBuscadorEjecutado] = useState(false);
    const [actualizarListado, setActualizarListado] = useState(false);
    const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
    const [modalStateComprobantes, setModalStateComprobantes] = useState(false);
    const [dataComprobantesList, setDataComprobantesList] = useState([]);
    const [modalStateExportar, setModalStateExportar] = useState(false);
    const [responseService, setResponseService] = useState(false);
    // Función para buscar los parametros del proyecto
    const clientData = JSON.parse(localStorage.getItem("clientData"))
    const imgUrl = clientData.dominio + '/static_content/img/' + clientData.owner_code + '_LOGO.JPG'

    console.log("responseService", responseService);

    useEffect(() => {

        const handleSearch = async () => {
            let id_cuenta;
            if (clienteSeleccionado) {
                id_cuenta = clienteSeleccionado.id_cuentas;
            } else {
                const user_cuentas = JSON.parse(
                    localStorage.getItem("siam-user-cuentas")
                );
                let userCuentasStorage = esArray(user_cuentas);
                if (userCuentasStorage.length < 2) {
                    id_cuenta = userCuentasStorage[0].id_cuentas;
                }
            }

            setOptions({
                ...options,
                sinFilas: false,
                idElementData: {
                    cliente: id_cuenta,
                    inputSearch: searchQuery,

                },
            });
            setBuscadorEjecutado(true);
            setActualizarListado(false);
        }

        actualizarListado && handleSearch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [buscadorEjecutado, searchQuery, actualizarListado]);

    const buttonExportar = (params) => (
        <Tooltip title="Exportar">
            <Button
                startIcon={<FileDownloadIcon />}
                onClick={() => {
                    toggleModalExportar();
                }}
                color="primary"
                variant="contained"
                style={{
                    color: '#FFFFFF',
                    fontFamily: 'Roboto, sans-serif',
                    minWidth: '120px',
                    width: '120px',
                    fontSize: '11px',
                    height: '30px',
                }}
            >
                Exportar
            </Button>
        </Tooltip>

    );

    let columns = [
        {
            field: "name",
            headerName: "Servicio",
            flex: 1,
            headerAlign: "center",
        },
        {
            field: "total",
            headerName: "Cantidad",
            flex: 0.5,
            headerAlign: "center",
        },
        {
            field: "actions",
            headerName: "Acciones",
            type: "actions",
            width: 150,
            minWidth: 150,
            maxWidth: 175,
            getActions: (params) => [
                <GridActionsCellItem
                    icon={
                        <Tooltip title={esObjetoNoVacio(params.row.comprobantes) ? "Ver Comprobantes (" + esArray(params.row.comprobantes?.comprobante).length + ")" : "Sin Comprobantes"}>
                            <span>
                                <VisibilityIcon />
                            </span>
                        </Tooltip>
                    }
                    onClick={() => {

                        if (params.row.comprobantes) {
                            setDataComprobantesList(esArray(params.row.comprobantes.comprobante));
                        }

                        toggleModalComprobantes(params.id);
                    }}
                    disabled={esObjetoNoVacio(params.row.comprobantes) ? false : true}
                    label="Comprobantes"
                />
            ],
        }
    ];



    const [options, setOptions] = useState({
        cols: columns,
        get: getComprobantesMovimientos,
        getPaginated: getComprobantesMovimientosPaginated,
        pageSize: [5, 10, 25],
        limit: 50,
        filter: true,
        exportData: true,
        server: true,
        sinFilas: true,
        paginar: "true",
        buttonExtraViewOn: true,
        ButtonExtraView: buttonExportar,
        setResponseService: setResponseService,

    });

    const toggleModalComprobantes = async () => {
        setModalStateComprobantes(!modalStateComprobantes);

    };

    const toggleModalExportar = async () => {
        setModalStateExportar(!modalStateExportar);

    };

    const handleExportPDF = async () => {
        const datos_array = responseService.data? responseService.data : [];
        const datos_general = {
            datos: datos_array,
            fecha_desde:searchQuery.input_fecha_desde || "",
            fecha_hasta: searchQuery.input_fecha_hasta || "",
        }

        await createMovimientosPDF(datos_general,imgUrl);

    };

    // const handleExportExcel = async () => {


    // };


    return (
        <div>
            {modalStateComprobantes && (
                <SimpleDialogComponent
                    open={modalStateComprobantes}
                    modalName={"Comprobantes"}
                    child={<ComprobantesTable data={dataComprobantesList} />}
                    setPushData={toggleModalComprobantes}
                    handleClose={toggleModalComprobantes}
                    buttonEnviar={false}
                    buttonCancelar={true}
                />
            )}

            {modalStateExportar && (
                <SimpleDialogComponent
                    open={modalStateExportar}
                    modalName={"Exportar"}
                    child={
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginTop: '20px',
                                    width: '100%', // Asegura que el contenedor tome todo el ancho disponible
                                }}
                                >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleExportPDF}
                                >
                                    Exportar PDF
                                </Button>
                            </div>

                    }
                    setPushData={toggleModalExportar}
                    handleClose={toggleModalExportar}
                    buttonEnviar={false}
                    buttonCancelar={true}
                />
            )}

            {/* Se creo un componente aparte para el tema de la busqueda, asi no se produce delay/demora al escribir */}
            <BuscadorGeneralMovimientos
                setSearchQuery={setSearchQuery}
                setBuscadorEjecutado={setBuscadorEjecutado}
                clienteSeleccionado={clienteSeleccionado}
                setClienteSeleccionado={setClienteSeleccionado}
                setOptions={setOptions}
                options={options}
                setActualizarListado={setActualizarListado} />

            {buscadorEjecutado ? (
                <div style={{ marginTop: "20px" }}>
                    <ListTablePaginated options={options} />
                </div>
            ) : (
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    style={{ height: "70vh" }}
                >
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <img
                            src={imgUrl}
                            alt="Bienvenido"
                            style={{ maxWidth: "20%", height: "auto", marginBottom: 20 }}
                        />

                    </Grid>
                </Grid>
            )}

        </div>
    );
}
